module.exports = __webpack_public_path__ + "static/media/tiktokPride.7a7c361f.jpeg";